'use client';

import React from 'react';

import { useTranslations } from 'next-intl';

import { RatingStrategy } from '@/api/copy-trading/types';
import { WithTrendColor } from '@/blocks/components/WithTrendColor';
import { FormatPercent } from '@/blocks/formatters';
import { isFiniteNumber } from '@/utils/number';

import { StrategyStatChip, StrategyStatItemsContainer } from '@/app/[lang]/copy-trade/(shared)/TradersCard';

export function BestTraderStatsBlock({ strategy: trader }: { strategy: RatingStrategy }) {
  const tr = useTranslations('pages.priceCharts.asset.sections.sidebar.bestTrader');

  return (
    <StrategyStatItemsContainer>
      <StrategyStatChip
        name={tr.rich('total.label')}
        value={
          <WithTrendColor valueToCalculateTrend={trader.totalYield}>
            <FormatPercent value={trader.totalYield} />
          </WithTrendColor>
        }
      />
      {isFiniteNumber(trader.dailyYield) ? (
        <StrategyStatChip
          name={tr.rich('today.label')}
          value={
            <WithTrendColor valueToCalculateTrend={trader.dailyYield}>
              <FormatPercent value={trader.dailyYield} />
            </WithTrendColor>
          }
        />
      ) : null}
    </StrategyStatItemsContainer>
  );
}
